import { Connection } from "src/api/connectApi/types";
import { ManifestFormType } from "src/connections/config/manifest/types";

export const convertBEConnectionToManifestConnectionInput = (
  connection: Connection,
): ManifestFormType => {
  if (!connection.manifest_version) {
    throw new Error(`Invalid connection type: ${connection.provider}`);
  }

  const inputs = connection.environment_configurations || {};

  return {
    name: connection.name,
    data_retention: connection.data_retention,
    resource_configs: connection.resource_configs.map((rc) => ({
      ...rc,
      disable_sensitive_data_stripping:
        rc.disable_sensitive_data_stripping ?? false,
    })),
    inputs,
    is_sandbox: connection.is_sandbox,
    disable_credential_bg_jobs: connection.disable_credential_bg_jobs,
  };
};
